import { LdoJsonldContext } from "@ldo/ldo";

/**
 * =============================================================================
 * typeIndexContext: JSONLD Context for typeIndex
 * =============================================================================
 */
export const typeIndexContext: LdoJsonldContext = {
  type: {
    "@id": "@type",
    "@isCollection": true,
  },
  TypeRegistration: {
    "@id": "http://www.w3.org/ns/solid/terms#TypeRegistration",
    "@context": {
      type: {
        "@id": "@type",
        "@isCollection": true,
      },
      forClass: {
        "@id": "http://www.w3.org/ns/solid/terms#forClass",
        "@type": "@id",
      },
      instance: {
        "@id": "http://www.w3.org/ns/solid/terms#instance",
        "@type": "@id",
        "@isCollection": true,
      },
      instanceContainer: {
        "@id": "http://www.w3.org/ns/solid/terms#instanceContainer",
        "@type": "@id",
        "@isCollection": true,
      },
    },
  },
  forClass: {
    "@id": "http://www.w3.org/ns/solid/terms#forClass",
    "@type": "@id",
  },
  instance: {
    "@id": "http://www.w3.org/ns/solid/terms#instance",
    "@type": "@id",
    "@isCollection": true,
  },
  instanceContainer: {
    "@id": "http://www.w3.org/ns/solid/terms#instanceContainer",
    "@type": "@id",
    "@isCollection": true,
  },
};
